export default {
  about: {
    hero: {
      eyebrow: 'Chi siamo',
      title: 'Personale. Professionale. Preciso.',
      lead: '{{name}} significa videosorveglianza pianificata individualmente e assistenza personale da un unico fornitore.',
    },
    story: {
      quote: '«Invece di vendere pacchetti preconfezionati, ogni immobile viene considerato in base alle sue reali esigenze – dalle aree immagine desiderate ai punti di montaggio, registrazione e configurazione dell’app.»',
      p1: '{{name}} è guidata da {{owner}}, il tuo contatto personale dalla prima consulenza all’assistenza continua. Lavora nella sicurezza da oltre 20 anni e ha realizzato centinaia di progetti per privati e aziende.',
      p2: 'La lunga esperienza copre pianificazione e installazione di sistemi di telecamere in case, condomini, negozi, uffici, studi, ristorazione, magazzini, officine e aree produttive. Ogni progetto è considerato individualmente.',
      p3: 'A seconda dei requisiti del progetto, {{name}} utilizza sistemi collaudati di Hikvision e Safire. Si possono pianificare anche soluzioni di altri produttori.',
      p4: '{{name}} non si vede come semplice venditore, ma come partner a lungo termine. Dopo l’installazione resta il contatto personale.',
    },
    owner: {
      subtitle: 'Tecnologia di sicurezza da Hainburg',
      photoPlaceholder: 'Foto del titolare in arrivo',
      role: 'Titolare e contatto',
    },
    milestonesTitle: 'Esperienza che si fa notare',
    milestones: {
      '0': { year: 'Oltre 20 anni', desc: 'Esperienza nella pianificazione e installazione di sistemi di telecamere per privati e aziende nella regione Reno-Meno.' },
      '1': { year: 'Centinaia di progetti', desc: 'Da case a negozi a grandi impianti: ogni progetto pianificato individualmente.' },
      '2': { year: 'Indipendente dal produttore', desc: 'Scegliamo la tecnologia adatta alle tue esigenze, da vari produttori rinomati.' },
    },
    valuesTitle: 'Ciò che rende speciale {{name}}',
    values: {
      '0': { title: 'Pianificazione individuale', desc: 'Nessun pacchetto preconfezionato. Ogni immobile è considerato in base alle reali esigenze.' },
      '1': { title: 'Esecuzione professionale', desc: 'Installazione pulita, orientamento corretto e cablaggio professionale.' },
      '2': { title: 'Collegamento digitale', desc: 'App, accesso remoto e notifiche, configurati e spiegati.' },
      '3': { title: 'Assistenza personale', desc: 'Un solo contatto. Affidabile. Anche dopo l’installazione.' },
    },
    cta: {
      title: 'Conoscici',
      lead: 'Un primo colloquio senza impegno mostra subito se facciamo al caso tuo. Saremo lieti di conoscere il tuo progetto.',
      primary: 'Fissa un appuntamento',
      secondary: 'Domande frequenti',
    },
  },
};